export const getLatestContract = (arrayAdditionalContracts) => {
	return arrayAdditionalContracts.reduce((latest, current) => {
		let currentDate = new Date(current.dateFrom.split('.').reverse().join('-'))
		let latestDate = new Date(latest.dateFrom.split('.').reverse().join('-'))
		return currentDate > latestDate ? current : latest
	}, arrayAdditionalContracts[0])
}
